export const MERCHANT_PORTAL_API_TOKEN = '3wIjNvHi74LNBiv6-QnwIYmuVmbvfetuV7MTB0Vg1Jo';
export const MERCHANT_PORTAL_API_TOKEN_PREVIEW = 'tPh99QhTRC-HbUdtqI9JfTuNzZsSL5pBKDjBcup322c';
export const MERCHANT_PORTAL_SPACE_ID = 'hynnffk3balp';
export const NAME = 'cms';
export const SET_CMS_ENVIRONMENT = 'SET_CMS_ENVIRONMENT';
export const CMS_ENVIRONMENT_SESSION_STORAGE_KEY = 'mage-cms.cms-environment';
